/** @format */

import '../css/Experience.css';

// import experienceImg from '../images/experience-img.png';
import dragonBlender from '../images/dragon-blender.mp4';
import { IoPlay, IoLogoWhatsapp } from 'react-icons/io5';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { useDispatch } from 'react-redux';
import { openVideo } from '../features/video';

const Experience = () => {
  const dispatch = useDispatch();

  const handleClink = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute('href');
    const location = document.querySelector(target).offsetTop;
    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  return (
    <div className='experience'>
      <div className='experience-container container padding'>
        <img
          className='experience-s-1'
          src='https://alimasha.net/template/maxdi/assets/images/shape/experience/experience-s-1.png'
          alt=''
        />
        <img
          className='experience-s-2'
          src='https://alimasha.net/template/maxdi/assets/images/shape/experience/experience-s-2.png'
          alt=''
        />
        {/* <img
          className='experience-s-3'
          src='https://alimasha.net/template/maxdi/assets/images/shape/experience/experience-s-3.png'
          alt=''
        /> */}
        <img
          className='experience-s-4'
          src='https://alimasha.net/template/maxdi/assets/images/shape/experience/experience-s-4.png'
          alt=''
        />
        <div className='experience-wrapper'>
          <div className='experience-content'>
            <h4 className='experience-subtitle'>
              CURSO ONLINE EN VIVO
            </h4>
            <h2 className='experience-title'>
              <span>Crea y Anima </span>
              Personajes en <span>Blender</span>
            </h2>
            <p className='experience-paragraph'>
              Vive una gran experiencia y aprende desde cero a crear
              fantásticos personajes en Blender.
            </p>
            <p className='experience-paragraph'>
              Lo mejor es que no necesitas tener conocimientos
              previos.
            </p>
            <div className='experience-inscription'>
              <a
                className='experience-btn'
                href='https://wa.link/5s5s0m'
                target='_blank'
                rel='noreferrer'>
                <IoLogoWhatsapp
                  size={20}
                  style={{ marginRight: '1ch' }}
                />
                Inscríbete
              </a>
              <a
                className='experince-offer'
                href='#entrenamientos'
                onClick={handleClink}>
                Aplica al 65%Dto
                <HiOutlineArrowNarrowRight
                  size={34}
                />
              </a>
            </div>
          </div>
          <div className='experience-thumb'>
            <div className='experience-video-btn'>
              <button
                className='popup-video'
                onClick={() => {
                  dispatch(
                    openVideo({
                      modal: true,
                      url: 'https://www.youtube.com/watch?v=VXvaSAsrJw8',
                      type: 'common',
                    })
                  );
                }}>
                <IoPlay />
              </button>
            </div>
            <figure className='experience-thumb-image'>
              {/* <img src={experienceImg} alt='' /> */}
              <video autoPlay playsInline loop muted width={'100%'}>
                <source src={dragonBlender} type='video/mp4' />
              </video>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
